import { useEffect, useRef, useState } from "react";
import CaptchaManager, {
  CaptchaBusiness,
} from "project-config/services/captcha";
import request from "project-config/services/request/request";
import { message as antdMessage } from "antd";
import { useTranslation } from "react-i18next";
import { isEn } from "project-config/utils/env";

export function useSendCode(isDomestic: boolean, countDown: number) {
  const [sendCodeDisable, setSendCodeDisable] = useState(false);
  const [sending, setSending] = useState(false);
  const captchaManagerRef = useRef(CaptchaManager.captcha);
  const { t } = useTranslation();
  const timer = useRef<NodeJS.Timer>();
  const [countdown, setCountdown] = useState(0);
  const startCountDown = () => {
    if (timer.current) {
      clearInterval(timer.current);
    }
    setCountdown(countDown);
    timer.current = setInterval(() => {
      setCountdown((prev) => {
        const next = prev - 1;
        if (next <= 0) {
          setSendCodeDisable(false);
          window.clearInterval(timer.current);
        }
        return next;
      });
    }, 1000);
  };

  useEffect(() => {
    if (captchaManagerRef.current) return;
    CaptchaManager.init(
      !isEn() ? CaptchaBusiness.Renderbus : CaptchaBusiness.Foxrenderfarm
    ).then((res) => {
      captchaManagerRef.current = res;
    });
  }, [isDomestic]);

  const sendCode = async ({ url, params }: { url: string; params: object }) => {
    setSendCodeDisable(true);
    setSending(true);
    const requestCode = async (_params: object) => {
      const { code, message } = await request.post(url, {
        ...params,
        ..._params,
      });
      setSending(false);
      if (code === 200) {
        startCountDown();
        antdMessage.success(t(`validate_code_send`, { ns: "error" }));
      } else {
        antdMessage.error(t(`${message}`, { ns: "center" }));
        setSendCodeDisable(false);
      }
    };
    if (captchaManagerRef.current || CaptchaManager.captcha) {
      CaptchaManager.show(async (captchaParams?: object) => {
        if (captchaParams) {
          await requestCode(captchaParams);
        } else {
          setSendCodeDisable(false);
          setSending(false);
        }
      }).catch(() => {
        setSendCodeDisable(false);
        setSending(false);
      });
    } else {
      await requestCode(CaptchaManager.errorCaptcha);
    }
  };

  return {
    sendCodeDisable,
    sending,
    sendCode,
    countdown,
  };
}
